import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toastMessage } from "../../common/toast";
import { Formik } from "formik";
import { ResetPasswordVS } from "../../../util/validation";
import { ResetPassword } from "../../../services/authService";
import EditProfileInput from "../../common/editProfileinput";
import "./style.css";

const ResetPasswordModal = ({ openModal, HideModal }) => {
  const user = useSelector((state) => state.root.user);
  const initialValues = {
    newpassword: "",
  };
  const handleResetPass = async (values, action) => {
    let obj = {
      email: user?.user?.email,
      password: values.newpassword,
    };
    await ResetPassword(user?.token, obj)
      .then((res) => {
        if (res.statusText === "OK") {
          action.setSubmitting(false);
          toastMessage(res.data, "success");
          HideModal();
        }
      })
      .catch((error) => {
        console.log(error);
        action.setSubmitting(false);
        toastMessage(error.response.data, "error");
      });
  };
  return (
    <Modal
      size="lg"
      backdrop="static"
      show={openModal}
      onHide={HideModal}
      centered
      dialogClassName="reset-modal-dialog"
    >
      <button
        type="button"
        className="close custom-modal-close"
        onClick={HideModal}
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div className="modal-body modal-body-flex">
        <div className="login-form" style={{ width: "100%" }}>
          <Formik
            initialValues={initialValues}
            onSubmit={(values, action) => handleResetPass(values, action)}
            validationSchema={ResetPasswordVS}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleSubmit,
              isSubmitting,
            }) => (
              <div className="formik-container2">
                <h4 className="margin3">Reset Passsword</h4>
                <div className="col-12 margin1">
                  <EditProfileInput
                    type="password"
                    placeholder="New Password"
                    onChange={handleChange("newpassword")}
                    value={values.newpassword}
                  />
                  <div className="error pt-2">
                    {touched.newpassword && errors.newpassword
                      ? errors.newpassword
                      : ""}
                  </div>
                </div>

                <button
                  className="savebutton"
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                >
                  {isSubmitting ? (
                    <Spinner animation="grow" size="sm" />
                  ) : (
                    "Reset"
                  )}
                </button>
              </div>
            )}
          </Formik>
        </div>
      </div>
    </Modal>
  );
};

export default ResetPasswordModal;
